import React from "react";
import Card from "components/card";

const DetailCard = ({ title, icon: Icon , details }) => {
    return (
        <Card className="rounded-xl border">
            <div className="px-6 pt-6 pb-6">
                <div className="flex flex-col gap-4">
                    <div className="flex items-center justify-center gap-2 mb-2">
                        {Icon && (
                            <div className="flex-shrink-0">
                                <div className="text-slate-600 flex items-center justify-center">
                                    <Icon className="w-4 h-4" />
                                </div>
                            </div>
                        )}
                        <h4 className="text-[16px] font-medium leading-tight">{title}</h4>
                    </div>

                    <div className="space-y-3">
                        {details?.map((detail, idx) => (
                            <div key={idx} 
                                className="flex justify-between items-baseline gap-2"
                            >
                                <span className="text-gray-500 leading-tight">{detail.label}:</span>
                                <span className="font-medium leading-tight break-all sm:text-right">{detail.value}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default DetailCard;
